// src/utils/getProfilePathByContext.js

/**
 * Détermine la route "Profil" correcte selon le contexte.
 *
 * Priorité :
 * 1) pathname (conserve l’espace courant)
 * 2) profile.role / partner_type (fallback)
 *
 * @param {string} pathname - location.pathname
 * @param {object|null} profile - profil Supabase
 * @returns {string}
 */
export function getProfilePathByContext(pathname, profile) {
  const p = typeof pathname === "string" ? pathname : "";

  // 1) Contexte URL prioritaire
  if (p.startsWith("/expert")) return "/expert/profile";
  if (p.startsWith("/partner")) return "/partner/profile";
  if (p.startsWith("/family-office")) return "/family-office/profile";
  if (p.startsWith("/team")) return "/team/profile";
  if (p.startsWith("/admin")) return "/admin/profile";
  if (p.startsWith("/delegated")) return "/delegated/profile";

  // 2) Fallback par rôle
  const role = profile?.role;
  if (role === "expert") return "/expert/profile";

  if (role === "partner") {
    // si plus tard tu scindes le profil partner par vertical
    return "/partner/profile";
  }

  if (role === "family_office") return "/family-office/profile";
  if (role === "team") return "/team/profile";
  if (role === "admin") return "/admin/profile";

  if (profile?.account_mode === "delegated") return "/delegated/profile";

  // 3) Défaut client
  return "/profile";
}
